import React from 'react';

export function InstallIcon(props) {
	return (<svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
		<path d="M3.83301 12.5007V14.1673C3.83301 14.8304 4.0964 15.4662 4.56524 15.9351C5.03408 16.4039 5.66997 16.6673 6.33301 16.6673H14.6663C15.3294 16.6673 15.9653 16.4039 16.4341 15.9351C16.9029 15.4662 17.1663 14.8304 17.1663 14.1673V12.5007M10.4997 13.334V3.33398M10.4997 13.334L7.16634 10.0007M10.4997 13.334L13.833 10.0007" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
	</svg>);
}